import { UserFrontPrivate } from "@project/shared-types";
import { createContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { GetUserPrivateAPI, UserDeviceAPI } from "../../api/UserAPI";
import { useLocalStorage } from "../../hooks/useLocalStoreg";
import { Logger } from "../../tools/debugLogger";
import { collectDeviceInfo, encryptPayload } from "./devices";

// Создаем контекст для авторизованного пользователя
export const UserContext = createContext<{
  user: UserFrontPrivate | null;
  setUser: (user: UserFrontPrivate | null) => void;
}>(null!);

/**
 * UserProvider - компонент-провайдер для хранения данных
 * об авторизованном пользователе.
 *
 * Использует хук useLocalStorage для сохранения данных
 * между сессиями в localStorage.
 *
 * @param props.children - дочерние компоненты, которые будут иметь
 * доступ к контексту пользователя
 */
export const UserProvider = ({ ...props }) => {
  const logger = new Logger(undefined, true);
  const [user, setUser] = useLocalStorage<UserFrontPrivate | null>(
    "user_auth5",
    null
  );
  const [deviceId, setDeviceId] = useLocalStorage<string | null>(
    "sdk_id2",
    null
  );
  const navigate = useNavigate();
  const location = useLocation();

  const getUserPrivate = async () => {
    try {
      const response = await GetUserPrivateAPI({});
      logger.log("getUserPrivate response", response);
      if (response.user) {
        setUser(response.user);
        if (deviceId == null) {
          try {
            const deviceId = uuidv4();
            setDeviceId(deviceId);
            const deviceInfo = await collectDeviceInfo(deviceId);
            await UserDeviceAPI({ data: encryptPayload(deviceInfo) });
          } catch (error) {
            logger.error("Ошибка при создании устройства:", error);
          }
        }
      }
    } catch (error) {
      logger.error("Ошибка при получении пользователя:", error);

      localStorage.removeItem("viw_token");
      navigate("/authorize/auth/");
      return;
    } finally {
    }
  };

  useEffect(() => {
    if (location.pathname.includes("/authorize/") || user == null) {
      getUserPrivate();
    }
  }, [location.pathname]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {props.children}
    </UserContext.Provider>
  );
};
